import type { SwaggerResponse } from '@/services/config';
import { Http } from '@/services/httpRequest';
import { _CONSTANT0, template } from '@/services/services';

/** A generated service function; its path template hangs off it as `key`. */
interface GeneratedEndpoint {
    key: string;
}

type BodyMethod = 'postRequest' | 'putRequest' | 'patchRequest';

/**
 * Sends a generated endpoint's request with the body typed as the API takes it.
 *
 * swagger-typescript turns a `nullable` property into an optional one, so a request that clears
 * a field with `null` cannot go through the generated function's body type. This keeps that
 * function's path template, path parameters and JSON headers, and changes only the body type.
 */
export function sendWireBody<TBody>(
    method: BodyMethod,
    endpoint: GeneratedEndpoint,
    pathParams: Record<string, number | string>,
    body: TBody
): Promise<SwaggerResponse<unknown>> {
    return Http[method](template(endpoint.key, pathParams), undefined, body, undefined, {
        ..._CONSTANT0,
        headers: { ..._CONSTANT0.headers },
    });
}
